import { Sky, BakeShadows, SoftShadows, OrbitControls, Environment, ContactShadows } from "@react-three/drei";
import { use, useRef, useState, useEffect } from "react";
import { Canvas, useThree, useFrame } from "@react-three/fiber";
import { Perf } from "r3f-perf";
import { Suspense } from "react";
import CityBlock from "./CityBlock.jsx";
import gsap from "gsap";

export default function City({ blocks }) {
  const refs = [useRef(), useRef(), useRef(), useRef()];
  const [hovered, setHovered] = useState(false);
  const [visibleBlocks, setVisibleBlocks] = useState(blocks.slice(0, 4));
  const [scaleFactor, setScaleFactor] = useState(0);
  const [isPortrait, setIsPortrait] = useState(false);
  const tl = [];
  const lockedBlocks = [false, false, false, false];

  useEffect(() => {
    document.body.style.cursor = hovered ? "pointer" : "auto";
    return () => (document.body.style.cursor = "auto");
  }, [hovered]);

  const distance = 0.75;
  const positions = [
    [-distance, 0, distance],
    [distance, 0, distance],
    [distance, 0, -distance],
    [-distance, 0, -distance],
  ];

  function animatePointerOver(i) {
    // const t = gsap.timeline();
    // t.to(refs[i].current.position, {
    //   y: 0.1,
    //   duration: 0.25,
    //   ease: "power2.out",
    // });
  }

  function animatePointerOut(i) {
    // const t = gsap.timeline();
    // t.to(refs[i].current.position, {
    //   y: 0,
    //   duration: 0.25,
    //   ease: "power2.out",
    // });
  }

  function animateSwap(i) {
    if (lockedBlocks[i]) {
      return;
    }
    lockedBlocks[i] = true;
    tl[i] = gsap.timeline();

    tl[i]
      .to(refs[i].current.scale, {
        x: 0.25,
        y: 0.25,
        z: 0.25,
        duration: 0.25,
        ease: "back.in",
        onComplete: () => {
          swap(i);
        },
      })
      .to(refs[i].current.scale, {
        x: 1,
        y: 1,
        z: 1,
        duration: 0.25,
        ease: "back.out",
        onComplete: () => {
          lockedBlocks[i] = false;
        },
      });
  }

  // Swap a block with the next one
  function swap(i) {
    const currentIndex = blocks.findIndex((b) => b.path === visibleBlocks[i].path);
    let nextIndex = (currentIndex + Math.floor(Math.random() * (blocks.length - 1)) + 1) % blocks.length;
    const newVisibleBlocks = [...visibleBlocks];
    newVisibleBlocks[i] = blocks[nextIndex];
    setVisibleBlocks(newVisibleBlocks);
    refs[i].current.rotation.y = Math.floor(Math.random() * 4) * Math.PI * 0.5;
  }

  // Adjust scale factor based on canvas size & useFrame
  function HelperElement() {
    const { size } = useThree();
    setScaleFactor(Math.min(size.width / size.height, 1.25));
    setIsPortrait(window.innerWidth < window.innerHeight);
  }

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Canvas
        shadows
        camera={{
          fov: 45,
          near: 0.1,
          far: 200,
          position: [4, 4, 4],
        }}
      >
        <HelperElement />

        {/* <Perf position="bottom-right" /> */}

        {/* <BakeShadows />
        <SoftShadows size={25} samples={10} focus={0} /> */}

        <OrbitControls
          autoRotate
          autoRotateSpeed={0.5}
          makeDefault
          enablePan={false}
          enableZoom={isPortrait}
          minPolarAngle={Math.PI / 3}
          maxPolarAngle={Math.PI / 3}
        />
        {/* <color attach="background" args={["#c9d5d9"]} /> */}
        {/* <Sky sunPosition={[0, 1, 0]} /> */}
        {/* <directionalLight castShadow position={[0, -3, 0]} intensity={4.5} shadow-mapSize={[1024, 1024]} /> */}
        <ambientLight intensity={3} />

        <group scale={scaleFactor}>
          {visibleBlocks.map((block, i) => (
            <group
              position={positions[i]}
              ref={refs[i]}
              key={i}
              onClick={(e) => {
                animateSwap(i);
                e.stopPropagation();
              }}
              onPointerOver={(e) => {
                animatePointerOver(i);
                e.stopPropagation();
              }}
              onPointerOut={(e) => {
                animatePointerOut(i);
                e.stopPropagation();
              }}
            >
              <CityBlock block={block} onPointerOver={() => setHovered(true)} onPointerOut={() => setHovered(false)} />
            </group>
          ))}
        </group>

        <Environment preset="city" />
        <ContactShadows
          position={[0, -0.5, 0]}
          color="black"
          opacity={0.2}
          width={15}
          height={15}
          blur={1}
          far={5}
          scale={1}
          resolution={256}
        />
      </Canvas>
    </div>
  );
}
